import { ServerChildColumnType, ServerParentColumnType } from '../types';

export function isParentServerColumn(serverColumn: ServerChildColumnType | ServerParentColumnType) {
  return (serverColumn as any).children !== undefined;
}
